import { Container } from '@/components/base/container'
import { Heading } from '@/components/base/heading'
import { Text } from '@/components/base/text'
import { SingleColumnPage } from '@/components/page-layout'
import { useI18n } from '@/i18n/i18n-react'

export const FeatureNotAvailable = () => {
	const { L } = useI18n()

	return (
		<SingleColumnPage>
			<Container className='flex min-h-[400px] items-center justify-center'>
				<div className='flex flex-col items-center gap-4 text-center'>
					<Heading level='h1'>{L.General.FeatureNotAvailable()}</Heading>
					<Text className='text-ui-fg-subtle'>{L.General.FeatureNotAvailableDescription()}</Text>
				</div>
			</Container>
		</SingleColumnPage>
	)
}
